import { ExportFileType } from '@common/ts/enums';

/**
 * Downloads data as a file with appropriate MIME type
 * @param content - The content to download
 * @param filename - The filename to use for the downloaded file
 */
const downloadFile = (content: string, filename: string): void => {
  // Determine content type based on file extension
  const fileExtension = filename.split('.').pop()?.toLowerCase();
  const isCSV = fileExtension === ExportFileType.CSV;
  const mimeType = `text/${isCSV ? ExportFileType.CSV : 'plain'};charset=utf-8;`;

  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default downloadFile;
